import { render, staticRenderFns } from "./uncombat_knockout.vue?vue&type=template&id=5020c78c&scoped=true"
import script from "./uncombat_knockout.vue?vue&type=script&lang=js"
export * from "./uncombat_knockout.vue?vue&type=script&lang=js"
import style0 from "./uncombat_knockout.vue?vue&type=style&index=0&id=5020c78c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5020c78c",
  null
  
)

export default component.exports